import React from 'react';

/** Renders the server's undo verdict (the WastageRevertButton pattern); /undo re-checks it. */
export default function UndoDishButton({ code, reason, disabled = false, onClick }) {
  if (code) {
    const why = reason || 'This dish can no longer be undone.';
    return (
      <button type="button" className="nim-undo-locked" disabled title={why} aria-label={`Undo locked: ${why}`}>
        🔒 Undo
      </button>
    );
  }
  return <button type="button" className="um-undo-btn" disabled={disabled} onClick={onClick}>Undo</button>;
}
